/** @jsx h */
import { h, Component } from 'preact'
import JourneyClose from '../journeys/Close'

export default class FullCard extends Component {
  constructor (props) {
    super(props)
    this.state = { isShowBack: false }
  }

  flipCard = () => {
    this.setState(state => ({
      isShowBack: !state.isShowBack
    }))
  }

  render ({ front: FrontCard, back: BackCard, inJourney, content }, { isShowBack }) {
    const closeButton = inJourney ? null : <JourneyClose />

    return (
      <div class='FullCard'>
        {closeButton}
        {isShowBack
          ? <BackCard {...content} flipCard={this.flipCard} />
          : <FrontCard {...content} flipCard={this.flipCard} />}
      </div>
    )
  }
}
